<template>
  <o-view>
    <o-nav-bar :has-back-button="true" title="Fiets" />
    <o-map :is-large="true" :markers="markers" />
    <o-block-list title="Kies een aanbieder">
      <o-list-item
        icon="brands/cambio"
        icon-style="logo"
        label="Cambio"
        link="/sales/car/cambio"
      />
    </o-block-list>
  </o-view>
</template>

<script>
import OMap from '@/components/OMap.vue'

export default {
  name: 'Car',
  components: {
    OMap
  },
  data() {
    return {
      markers: [
        {
          coordinates: [3.715, 51.05],
          type: 'cambio',
          title: 'Cambio A',
          link: 'poi/cambio'
        },
        {
          coordinates: [3.723, 51.053],
          type: 'cambio',
          title: 'Cambio B',
          link: 'poi/cambio'
        },
        {
          coordinates: [3.72, 51.055],
          type: 'cambio',
          title: 'Cambio C',
          link: 'poi/cambio'
        }
      ]
    }
  }
}
</script>
